/* RadioToggleButtons.tsx
   Version: 1.0.0
   Date: 2021-06-09
*/

// eslint-disable-next-line
import React from "react";

import { AppContext } from '../AppContext';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface RadioToggleButtonsProps {
    entries: string[];
    selectedOption: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface RadioToggleButtonsState {
}


export default class RadioToggleButtons extends React.Component<RadioToggleButtonsProps, RadioToggleButtonsState> {

    // context
	static contextType = AppContext;
	context!: React.ContextType<typeof AppContext>;

    public render(): JSX.Element {
        return (
            <React.Fragment>
                {this.props.entries
                    .map( (entry, idx) => {
                        return <React.Fragment key={idx}>
                                <input type="radio" className="btn-check" name="options" id={'option' + entry} autoComplete="off" checked={this.props.selectedOption === entry} onChange={this.props.onChange} />
                                <label className="toggle-button" htmlFor={'option' + entry}>{ entry }</label>
                            </React.Fragment>
                    })
                }   
            </React.Fragment>
        )
    }
}
